import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { TIMER_TYPE } from '../config/timer/type';
import { BaseTimerData } from './types/timer';

type BaseTimerState = {
    timers: BaseTimerData[];
    addTimer: (newTimer: BaseTimerData) => void;
    updateTimer: (id: string, updatedProps: Partial<BaseTimerData>) => void;
    removeTimer: (id: string) => void;
    getTimer: (id: string) => BaseTimerData | undefined;
};

export const useBaseTimerStore = create<BaseTimerState>()(
    persist(
        (set, get) => ({
            timers: [
                {
                    id: 'preset-math',
                    type: TIMER_TYPE.BASE,
                    title: 'Math Kru Ton',
                    time: 20,
                    isMinutes: true,
                    pointColorIndex: 0,
                },
                {
                    id: 'preset-shenron',
                    type: TIMER_TYPE.BASE,
                    title: 'Summon the Shenron',
                    time: 3,
                    isMinutes: true,
                    pointColorIndex: 1,
                },
                {
                    id: 'preset-icecream',
                    type: TIMER_TYPE.BASE,
                    title: 'Buy an ice cream to Buu',
                    time: 5,
                    isMinutes: true,
                    pointColorIndex: 2,
                },
            ],
            addTimer: (newTimer) => set((state) => ({ timers: [...state.timers, newTimer] })),
            updateTimer: (id, updatedProps) =>
                set((state) => ({
                    timers: state.timers.map((timer) => (timer.id === id ? { ...timer, ...updatedProps } : timer)),
                })),
            removeTimer: (id) =>
                set((state) => ({
                    timers: state.timers.filter((timer) => timer.id !== id),
                })),
            getTimer: (id) => get().timers.find((timer) => timer.id === id),
        }),
        {
            name: 'base-timer-store',
        }
    )
);
